import React from 'react';

import {GameCenterHeaderModuleProps} from "../models/game-center-header-module.props";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {GameCenterHeaderModuleController} from "../game-center-header-module.controller";
import {GameCenterHeaderModuleContent} from "./game-center-header-module.content";
import {GameCenterHeaderClearButton} from "./game-center-header-module.clear-button";
import styles from "../styles/game-center-header.module.scss";
import classNames from "classnames";
import {Loader} from "../../../../../core/components/loading/loader";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../../../core/consts";
import {GameCenterHeaderModulePlaceholder} from "./placeholders/game-center-header-module.placeholder";
import useHexToRgba from "../../../../../infrastructure/hooks/useHexToRgba";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";
import {useCompetitorsBgColors} from "../../../../../infrastructure/hooks/useCompetitorBgColors";

export class GameCenterHeaderModuleComponentProps extends GameCenterHeaderModuleProps {
}

const GameCenterHeaderModuleComponent = ({controller}: GameCenterHeaderModuleComponentProps) => {
  const {device, state} = controller;
  const {isSmallView, isLargeView, isRtl} = device;
  const {isWidget, homeCompetitor, awayCompetitor} = state;
  const surfaceSecondaryHex = useThemeColor(COLORS.surfaceSecondary)

  const cardProps = {
    controller,
    className: classNames({[styles.small_view]: isSmallView}, {[styles.full_view]: isLargeView && isWidget}),
  };

  const loaderProps = {
    when: state.fetchingState === FETCHING_STATES.fetching || state.componentState === COMPONENT_STATES.loading,
    Component: GameCenterHeaderModulePlaceholder,
    componentProps: {
      device,
    }
  }

  const [homeColor, awayColor] = useCompetitorsBgColors(homeCompetitor, awayCompetitor, surfaceSecondaryHex)

  const homeCompetitorColor = useHexToRgba(homeColor, 0.3);
  const awayCompetitorColor = useHexToRgba(awayColor, 0.3);
  const backgroundColor = useHexToRgba(surfaceSecondaryHex, 0.3);

  const containerProps = {
    className: classNames(styles.container, styles.game_background, {
      [styles.small_view]: isSmallView,
    }, {[styles.full_view]: isLargeView && isWidget}),
    style: {
      background: isRtl ? `
        radial-gradient(121.26% 75.73% at 0% 50.24%, ${awayCompetitorColor} 0%, ${backgroundColor} 80%),
        radial-gradient(121.26% 75.73% at 100% 50.24%, ${homeCompetitorColor} 0%, ${backgroundColor} 80%)`
        : `
        radial-gradient(121.26% 75.73% at 0% 50.24%, ${homeCompetitorColor} 0%, ${backgroundColor} 80%),
        radial-gradient(121.26% 75.73% at 100% 50.24%, ${awayCompetitorColor} 0%, ${backgroundColor} 80%)`,
    }
  }

  return (
    <>
      <GameCenterHeaderClearButton controller={controller}/>
      <Loader {...loaderProps}>
        <div {...containerProps}>
          {
            state.dataSource ? <div {...cardProps}>
              <GameCenterHeaderModuleContent controller={controller}/>
            </div> : null
          }
        </div>
      </Loader>
    </>
  );
}

const settings: ComposeSettings = {
  component: GameCenterHeaderModuleComponent,
  propsType: GameCenterHeaderModuleComponentProps,
  controllerType: GameCenterHeaderModuleController,

  createModule: true,
  observe: true,
};

export default Compose(settings);
